module.exports = __webpack_public_path__ + "img/lens-174-minus-02.d6704da0.png";